"use client";

import React from "react";
import { AuthProvider } from "@/components/providers/AuthProvider";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import { UserProvider } from "@/components/providers/UserProvider";
import { AdminViewProvider } from "@/components/providers/AdminViewProvider";
import { AnalyticsProvider } from "@/components/providers/AnalyticsProvider";
import { ToastProvider } from "@/components/ui/Toast";
import { DmRealtimeProvider } from "@/components/providers/DmRealtimeProvider";
import { NotificationsProvider } from "@/components/providers/NotificationsProvider";
import InactivityGuard from "@/components/security/InactivityGuard";
import AdminViewBanner from "@/components/AdminViewBanner";
import { useActivityTracker } from "@/hooks/useActivityTracker";

function ActivityTracker() {
  useActivityTracker();
  return null;
}

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ThemeProvider>
      <ActivityTracker />
      <UserProvider>
        <AdminViewProvider>
          <AnalyticsProvider>
            <ToastProvider>
              <DmRealtimeProvider>
                <NotificationsProvider>
                  <InactivityGuard minutes={90} maxSessionHours={24} />
                  <AdminViewBanner />
                  {children}
                </NotificationsProvider>
              </DmRealtimeProvider>
            </ToastProvider>
          </AnalyticsProvider>
        </AdminViewProvider>
      </UserProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
